import React from 'react'

import { withStyles, makeStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar';
import { Alert, AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
    alert: {
        width: "100%",
    },
}))

export default function GraniotSnackbar({ open, setOpen, status, message, x, y, className }) {
    const classes = useStyles()
    
    const [vertical, setVertical] = React.useState(y || 'bottom')
    const [horizontal, setHorizontal] = React.useState(x || 'center')

    const severity = typeof status === 'string' ? status : 'info';

  
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpen(false);
      };

    return <Snackbar className={className} open={open} autoHideDuration={15000} onClose={handleClose} anchorOrigin={{ vertical, horizontal }}>
    <Alert className={classes.alert} onClose={handleClose} severity={severity}>
      <AlertTitle>{message}</AlertTitle>
    </Alert>
  </Snackbar>
}
